import React, { FunctionComponent } from 'react'
import useTranslation from '../../hooks/useTranslation'
import CarlineGroup from '../../entities/CarlineGroup'
import CarlineGridGroup from '../carline-grid-group'
import style from './carlineGridView.css'
import CarlineGridViewPlaceholder from './CarlineGridViewPlaceholder'
import CarlineFilters from '../carline-filters'
import FilterIcon from '../../assets/media/icons/filter.svg'
import AttributeFilterResultPlaceholder from '../attribute-filters-placeholder'

export type Props = {
    carlineGroups: CarlineGroup[]
    isLoading: boolean
    filtersAreVisible: boolean
    carlineFiltersAreLoading: boolean
    toggleFiltersAreVisible: () => void
    carlineInRow?: number
}

const CarlineGridView: FunctionComponent<Props> = (props) => {
    const {
        carlineGroups,
        isLoading,
        filtersAreVisible,
        carlineFiltersAreLoading,
        toggleFiltersAreVisible,
        carlineInRow,
    } = props
    const { t } = useTranslation()
    const filtersOrCarlinesAreLoading = isLoading || carlineFiltersAreLoading
    const placeHolder = (carlineGroups.length === 0 && isLoading)
        ? <CarlineGridViewPlaceholder />
        : null

    const carlineGroupToggleElements = carlineGroups.map((carlineGroup) => (
        <CarlineGridGroup
            key={carlineGroup.id}
            carlineGroup={carlineGroup}
            carlineInRow={carlineInRow}
        />
    ))

    const availableCarlines = carlineGroups?.flatMap((carlineGroup) => carlineGroup.carlines)

    const toggleFilters = (): void => {
        toggleFiltersAreVisible()
    }

    const toggleButtonLabel = filtersOrCarlinesAreLoading
        ? t('loading')
        : filtersAreVisible
            ? t('carlineSelection.hideFilters')
            : t('carlineSelection.showFilters')

    // keep both styles for now for backward compatibility
    const gridStyle = carlineInRow
        ? {
            gridTemplateColumns: `repeat(${carlineInRow}, 1fr)`,
            '--carline-in-row': carlineInRow.toString(),
        } as React.CSSProperties
        : null

    return (
        <>
            <div className={style.toggleButtonWrapper}>
                <button
                    className={style.toggleButton}
                    onClick={toggleFilters}
                    type="button"
                    data-testid="filter-toggle"
                    disabled={carlineFiltersAreLoading}
                >
                    {toggleButtonLabel}
                    <FilterIcon className={style.icon} />
                </button>
            </div>
            <div hidden={!filtersAreVisible}>
                <CarlineFilters isLoading={filtersOrCarlinesAreLoading} layout="horizontal" />
            </div>
            <AttributeFilterResultPlaceholder hasAvailableResults={availableCarlines?.length !== 0}>
                <div className={style.list} style={gridStyle}>
                    {placeHolder}
                    {carlineGroupToggleElements}
                </div>
            </AttributeFilterResultPlaceholder>
        </>
    )
}

export default CarlineGridView
